import React from 'react';
import {
    withRouter,
    //Link
} from 'react-router-dom';
import UserCard from './UserCard';
import { Tabs, Tab } from './Tabs'
import {AddNewNodebook, PreviewNodebook} from './PreviewNodebook'
import {AddNewGroup, PreviewGroup} from './PreviewGroup'
//import PreviewOrganization from './PreviewOrganization'
import PreviewUser from './PreviewUser'
import SidebarNavigation from './SidebarNavigation'
import constants from '../ndbk-constants'
import Dropdown from './Dropdown'
import Toggler from './Toggler'
import NotFoundPage from '../pages/NotFoundPage';

class ProfilePage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: null,
            username: null,
            first_name: null,
            last_name: null,
            email: '',
            bio: '',
            avatar: '',
            followers: 0,
            isUser: false,
            nodebooks: [],
            groups: [],
            organizations: [],
            subscriptions: {
                nodebooks: [],
                users: [],
                groups: []
            },
            sort: {
                nodebooks: null,
                groups: null,
                organizations: null
            },
            sortBy: 'date_modified',
            followTab: 'nodebooks',
            sortDirection: 1,
            activities: []
        };

        this.fetchProfile = this.fetchProfile.bind(this)
        this.fetchGroups = this.fetchGroups.bind(this)
        this.fetchNodebooks = this.fetchNodebooks.bind(this)
        this.fetchOrganizations = this.fetchOrganizations.bind(this)
        this.fetchSubscriptions = this.fetchSubscriptions.bind(this)
        this.fetchActivities = this.fetchActivities.bind(this)
        this.followUser = this.followUser.bind(this)
        this.unfollowUser = this.unfollowUser.bind(this)

        this.fetchProfile()
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.username !== nextProps.match.params.username) {
            this.props = nextProps
            this.fetchProfile()
        } else {
            this.props = nextProps
        }
    }

    followUser() {
        fetch(`https://${constants.SERVER_IP}/api/user/${this.state.id}/subscribe`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ isFollowing: true, followers: (this.state.followers + 1) })
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    unfollowUser() {
        fetch(`https://${constants.SERVER_IP}/api/user/${this.state.id}/unsubscribe`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ isFollowing: false, followers: (this.state.followers - 1) })
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchProfile() {
        fetch(`https://${constants.SERVER_IP}/api/user/` + this.props.match.params.username, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ ...response.data }, () => {
                        this.fetchNodebooks(this.state.isUser)
                        this.fetchGroups(this.state.isUser)
                        this.fetchOrganizations(this.state.isUser)
                        this.fetchSubscriptions(this.state.isUser)
                        this.fetchActivities(this.state.isUser)
                    });
                    document.title = `${response.data.first_name} ${response.data.last_name} (${response.data.username}) - ${constants.WEBSITE_TITLE}`
                } else {
                    this.setState({ errCode: response.code })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchActivities(isUser) {
        fetch(`https://${constants.SERVER_IP}/api/${isUser ? '' : 'user/' + this.state.id + '/'}activities`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ activities: response.data })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchSubscriptions(isUser) {
        fetch(`https://${constants.SERVER_IP}/api/${isUser ? '' : 'user/' + this.state.id + '/'}subscriptions`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ subscriptions: response.data }, ()=>{ this.sort('following', 'date_modified')})
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchNodebooks(isUser) {
        fetch(`https://${constants.SERVER_IP}/api/${isUser ? '' : 'user/' + this.state.id + '/'}nodebooks`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ nodebooks: response.data }, ()=>{ this.sort('nodebooks', 'date_modified') })
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchGroups(isUser) {
        fetch(`https://${constants.SERVER_IP}/api/${isUser ? '' : 'user/' + this.state.id + '/'}groups`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ groups: response.data }, ()=>{ this.sort('groups', 'name')})
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            });
    }

    fetchOrganizations(isUser) {
        fetch(`https://${constants.SERVER_IP}/api/${isUser ? '' : 'user/' + this.state.id + '/'}organizations`, {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    this.setState({ organizations: response.data }, ()=>{ this.sort('organizations')})
                }
                return response.success;
            })
            .catch((error) => {
                console.error(error);
            })
    }

    compareFunction = (a,b,direction,sortBy) => {
        if (typeof a[sortBy] === 'string') {
            let first = a[sortBy].toLowerCase()
            let second = b[sortBy].toLowerCase()
            if (first>second) return 1*direction
            if (first === second) return 0
            else return -1*direction
        } else {
            let first = a[sortBy]
            let second = b[sortBy]
            if (first>second) return -1*direction
            if (first === second) return 0
            else return 1*direction
        }
    }

    sort = (type, sortBy = undefined) => {
        sortBy = (sortBy) ? sortBy : this.state.sortBy
        type = (type) ? type : this.props.match.params.tab;
        let nodebooks = this.state.nodebooks;
        let groups = this.state.groups;
        let organizations = this.state.organizations
        let direction = this.state.sortDirection;

        if (sortBy === 'date_modified' || sortBy === 'date_created') {
            // Test how timestamps behave with string comparisons
            direction = -1*this.state.sortDirection;
        }
        if (type === 'nodebooks' || type === undefined) {
            nodebooks.sort((a,b) => this.compareFunction(a,b,direction,sortBy));
            this.setState({ nodebooks: nodebooks })
        }
        if (type === 'groups' || type === undefined) {
            groups.sort((a,b) => this.compareFunction(a,b,direction,sortBy));
            this.setState({ groups: groups })
        }
        if (type === 'organizations' || type === undefined) {
            organizations.sort((a,b) => this.compareFunction(a,b,direction,sortBy));
            this.setState({ organizations: organizations })
        }
        if (type === "following") {
            let nodebooks = this.state.subscriptions.nodebooks
            let groups = this.state.subscriptions.groups
            let users = this.state.subscriptions.users
            let type = this.state.followTab
            if (type === "nodebooks") {
                nodebooks.sort((a,b) => this.compareFunction(a,b,direction,sortBy));
                this.setState({ subscriptions: {...this.state.subscriptions, nodebooks }})
            }
            if (type === "groups") {
                groups.sort((a,b) => this.compareFunction(a,b,direction,sortBy));
                this.setState({ subscriptions: {...this.state.subscriptions, groups }})
            }
            if (type === "users") {
                users.sort((a,b) => this.compareFunction(a,b,direction,sortBy));
                this.setState({ subscriptions: {...this.state.subscriptions, users }})
            }
        }
    }

    onSortChange = (e) => {
        this.setState({sortBy: e.target.value}, () => {
            this.sort();
        })
    }

    createNodebook = () => {
        fetch(`https://${constants.SERVER_IP}/api/nodebook_create`,
                {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title: 'New nodebook',
                    description: 'Description',
                    visibility: 'public',
                    //templates: this.state.templates.filter((value, id)=>value.selected===true).map((value, id)=>value.id)
                })
            })
            .then((response) => response.json())
            .then((response) => {
                    if (response.success) {
                        this.props.history.push(`/nodebook/${response.data.id}`);
                    }
                    return response.success;
                })
            .catch((error) => {
                    console.error(error);
            });
    }

    render() {
        if (constants.RENDER_LOGS===true) console.log('<ProfilePage render.')

        if (this.state.errCode === 403) {
            return <NotFoundPage title="403" message="Profile is private"/>
        }

        if (this.state.errCode === 404) {
            return <NotFoundPage title="404" message="Profile not found"/>
        }

        //var selectedTab = (['nodebooks', 'groups', 'organizations', 'activity', 'following'].indexOf(this.props.match.params.tab) !== -1) ? this.props.match.params.tab : 'nodebooks'
        var selectedTab = (['nodebooks', 'groups', 'organizations', 'following'].indexOf(this.props.match.params.tab) !== -1) ? this.props.match.params.tab : 'nodebooks'



        // let sortOptionsNodebooks = {
        //     "Date modified" : 'date_modified',
        //     "Title" : "title",
        //     "Views" : "views",
        //     "Followers" : "followers",
        //     "Date created" : 'date_created',
        // }

        // let sortOptionsGroups = {
        //     "Name" : "name",
        //     "Members" : "members",
        //     "Followers" : "followers"
        // }

        // let sortOptionsUsers = {
        //     "Followers" : "followers",
        //     "Username" : "username",
        //     "Views" : "views",
        //     "Likes" : "likes",
        //     "Nodebooks" : "nodebooks_count",

        // }

        // let sortOptionsOrganizations = {
        //     "Name" : "name",
        //     "Views" : "views",
        //     "Followers" : "followers"
        // }

        let _sortOptionsNodebooks = {
            date_modified: "Date modified",
            title: "Title",
            views: "Views",
            followers: "Followers",
            date_created: "Date created",
        }

        let _sortOptionsGroups = {
            name : "Name",
            views : "Views",
            followers : "Followers"
        }

        let _sortOptionsUsers = {
            followers: "Followers",
            username: "Username",
            views: "Views",
            likes: "Likes",
            nodebooks_count: "Nodebooks",
        }

        // let _sortOptionsOrganizations = {
        //     name : "Name",
        //     views : "Views",
        //     follower : "Followers"
        // }

        switch (selectedTab) {
            case 'groups' : var options = _sortOptionsGroups; break;
            default : options = _sortOptionsNodebooks;
        }

        if (selectedTab === "following") {
            switch(this.state.followTab) {
                case 'users' : options = _sortOptionsUsers; break;
                case 'groups' : options = _sortOptionsGroups; break
                default : options = _sortOptionsNodebooks;
            }
        }

        let defaultSort = {
            nodebooks : 'date_modified',
            groups : 'name',
            followers: 'date_modified'
        }

        /*let Selector = ({options}) => {
            return (
                <span>
                    {(this.props.match.params.tab === "following")
                    ?<select name="type" onChange={(e)=>{this.setState({followTab:e.target.value}, ()=>{this.sort()})}} value={this.state.followTab}>
                        <option value="nodebooks">Nodebooks</option>
                        <option value="users">Users</option>
                        <option value="groups">Groups</option>
                    </select>
                    :null
                    }
                    <select name="sort" onChange={this.onSortChange} value={this.state.sortBy}>
                        {
                            Object.keys(options).map(value=> {
                                return(
                                    <option key={value} value={options[value]}>{value}</option>
                                )
                            })
                        }
                    </select>
                    <button onClick = {()=>{this.setState({sortDirection:-1*this.state.sortDirection}, () => {this.sort()})}} >{(this.state.sortDirection<0)?'Ascending':'Descending'}</button>
                </span>
            )
        }*/

        return (
            <div className="main">
                <SidebarNavigation {...this.props} />
                <div className="main-content">
                    <UserCard {...this.props} {...this.state} unfollowUser={this.unfollowUser} followUser={this.followUser} />
                    <Tabs
                        Selector = {
                            <div className="selector" style={{ userSelect:'none', cursor:'pointer'}}>
                                <Toggler
                                    selectedTab={selectedTab}
                                    followTab={this.state.followTab}
                                    pre="Sort by: "
                                    values={options}
                                    className="sorter"
                                    onChange={val=>{this.onSortChange({
                                        target: {
                                            value: val
                                        }
                                    })}}
                                />
                                {
                                    (this.props.match.params.tab === "following")
                                    ?   <Toggler
                                            pre="Show: "
                                            className="sorter-switcher"
                                            values={{
                                                nodebooks:"Nodebooks",
                                                users:"Users",
                                                groups:"Groups"
                                            }}
                                            onChange={val=>{this.setState({followTab:val}, ()=>{this.sort()})}}
                                            />
                                    :   null
                                }
                            </div>
                        }
                        selectedTab={selectedTab}
                        onChangeTab={selectedTab => {
                            this.setState({sortBy: defaultSort[selectedTab], followTab:'nodebooks'}, () =>{
                                this.props.history.push(`/user/${this.props.match.params.username}/${selectedTab}`)
                                this.sort(selectedTab)
                            })

                        }} >
    {/* NODEBOOKS */}
                        <Tab name="nodebooks" title="Nodebooks">
                            <div className="container-fluid">
                                {/* <div className="row">
                                    <Selector options={sortOptionsNodebooks} />
                                </div> */}
                                <div className="row">
                                    {
                                        (this.state.nodebooks.length!==0)
                                            ? this.state.nodebooks.map(ndbk => <PreviewNodebook key={ndbk.id} info={ndbk} />)
                                            : (!this.state.isUser)
                                                    ? <div className="col-lg-12"><p>No nodebooks to display.</p></div>
                                                    : null
                                    }
                                    {
                                        (this.state.isUser)
                                            ? <AddNewNodebook createNodebook={this.createNodebook} />
                                            : null
                                    }
                                </div>
                            </div>
                        </Tab>
    {/* GROUPS */}
                        <Tab name="groups" title="Groups">
                            <div className="container-fluid">
                                {/* <div className="row">
                                    <Selector options={sortOptionsGroups} />
                                </div> */}
                                <div className="row">
                                    {
                                        (this.state.groups.length!==0)
                                            ? this.state.groups.map(group => <PreviewGroup key={group.id} info={group} />)
                                            : (!this.state.isUser)
                                                ? <div className="col-lg-12"><p>No groups to display.</p></div>
                                                : null
                                    }
                                    {
                                        (this.state.isUser)
                                            ? <AddNewGroup history={this.props.history} />
                                            : null
                                    }
                                </div>
                            </div>
                        </Tab>
    {/* ORGANIZATIONS */}
                        {
                            // TODO
                        }
    {/* FOLLOWING */}
                        <Tab name="following" title="Following">
                            <div className="container-fluid">
                                {(this.state.followTab === 'nodebooks')
                                ?<div className="row" >
                                    {
                                        (this.state.subscriptions.nodebooks.length!==0)
                                            ? this.state.subscriptions.nodebooks.map(ndbk => <PreviewNodebook key={ndbk.id} info={ndbk} />)
                                            : <div className="col-lg-12"><p>No nodebooks to display.</p></div>
                                    }
                                </div>
                                :null}
                                {(this.state.followTab === 'groups')
                                ?<div className="row" >

                                    {
                                        (this.state.subscriptions.groups.length!==0)
                                            ? this.state.subscriptions.groups.map(group => <PreviewGroup key={group.id} info={group} />)
                                            : <div className="col-lg-12"><p>No groups to display.</p></div>
                                    }
                                </div>
                                :null}
                                {(this.state.followTab === 'users')
                                ?<div className="row" >
                                    {
                                        (this.state.subscriptions.users.length!==0)
                                            ? this.state.subscriptions.users.map(user => <PreviewUser key={user.id} info={user} />)
                                            : <div className="col-lg-12"><p>No users to display.</p></div>
                                    }
                                </div>
                                :null}
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default withRouter(ProfilePage);



// WEBPACK FOOTER //
// ./src/components/ProfilePage.js